'use strict';
const angular = require('angular');

/*@ngInject*/
export function ViolationTicketsService($resource) {
  return $resource('/api/violations/:id', {
    name: '@_id'
  },{
    letter: {
      method: 'GET',
      url: "/api/violations/:id/letter/:level",
    },
    update: {
      method: 'PUT'
    },
    patch: {
      method: 'PATCH'
    },
    getByProperty: {
      method: 'GET',
      url: "/api/violations/property/:id",
      isArray: true
    },
    addAttachments: {
      method: 'PUT',
      url: "/api/violations/:id/attachments"
    },
    createPDFAndAttach: {
      method: 'GET',
      url: "/api/violations/:id/attach-letter/:level/:address"
    },
    sendAttachmentMail: {
      method: 'POST',
      url: "/api/violations/:id/attachments/mail"
    }
  });
}


export default angular.module('conduu.ViolationTicketsService', [])
  .factory('ViolationTicketsService', ViolationTicketsService)
  .name;



// WEBPACK FOOTER //
// ./client/components/violation-tickets/violation-tickets.service.js